








































































































































































































































import { Component, Vue, Prop, Inject } from "vue-property-decorator";

import Metadata from "@/components/app/metadata.vue";
import type { Route } from "@/@types/route-info/v2/v2.routes";
import type { CityFeature } from "@/@types/route-info/v2/v2.citys";
import StandartImage from "@/components/app/shared/image/standart-image.vue";
import SettingsPanel from "@/components/app/shared/btn&dd/settings-panel.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: { StandartModal, Metadata, StandartImage, SettingsPanel },
})
class RouteInfoV2RouteModal extends Vue {
  @Prop({ type: Object, default: null }) route!: Route | null;
  @Prop({ type: Array, default: () => [] }) citis!: CityFeature[];
  @Prop({ type: Boolean, default: false }) deleted!: boolean;

  @Inject("routeFolder") routeFolder!: string;

  getCityName(city: any): string {
    if (!city) return "—";
    if (typeof city === "string") {
      const found = this.citis.find((c) => c._id === city);
      return found ? this.$getLocale(found.properties.name) : city;
    }
    if (city.properties && city.properties.name) {
      return this.$getLocale(city.properties.name);
    }
    if (city.name) return this.$getLocale(city.name);
    return String(city);
  }

  get routeBestImage(): { img: string; folder: string } | null {
    if (!this.route || !this.route.src) return null;
    const src = this.route.src;
    const map: Array<{ name: string; folder: string }> = [
      { name: "image", folder: `${this.routeFolder}/image/hd` },
      { name: "background", folder: `${this.routeFolder}/background/hd` },
      { name: "poster", folder: `${this.routeFolder}/poster/hd` },
      {
        name: "vertical_poster",
        folder: `${this.routeFolder}/vertical_poster/hd`,
      },
      {
        name: "horizontal_poster",
        folder: `${this.routeFolder}/horizontal_poster/hd`,
      },
    ];
    for (const item of map) {
      const val = (src as any)[item.name];
      if (val) return { img: val, folder: item.folder };
    }
    return null;
  }

  get duration() {
    if (!this.route || !this.route.duration) return "—";
    return `${this.route.duration.totalDays || 0} ${this.$t(
      "route_info.route.days"
    )}`;
  }

  get season() {
    if (!this.route || !this.route.season) return "—";
    if (this.route.season.start && this.route.season.end) {
      return `${new Date(
        this.route.season.start
      ).toLocaleDateString()} - ${new Date(
        this.route.season.end
      ).toLocaleDateString()}`;
    }
    return (this.route.season.year || "—").toString();
  }

  get typeVariant() {
    switch (this.route && this.route.type) {
      case "railway":
        return "primary";
      case "river":
        return "info";
      case "combined":
        return "warning";
      default:
        return "secondary";
    }
  }

  get statusVariant() {
    switch (this.route && this.route.status) {
      case "active":
        return "success";
      case "draft":
        return "secondary";
      case "inactive":
        return "warning";
      case "archived":
        return "dark";
      default:
        return "secondary";
    }
  }
}
export default RouteInfoV2RouteModal;
